import { h, Component } from 'preact';
import { Link } from 'preact-router/match';
import { Text } from 'preact-i18n';

import store from '../../store';

import ServiceWrapper from './serviceWrapper'

import LazyComponent from '../../components/asyncComponent';

export default  class aService extends Component {
	render() {
		return (<ServiceWrapper {...this.props}>
				<article class="has-widget">
					<p>DolphinHost™ mākoņskaitļošanas datu centrā izvietota virtuālā telefona centrāle.</p>
					<h2>Priekšrocības</h2>
					<ul>
						<li>Tiešais optiskais pieslēgums nodrošina izcilu sarunu kvalitāti.</li>
						<li>Sveiciena teksts, valodas un sarunas veida izvēles iespēja klientam nospiežot taustiņu (IVR)</li>
						<li>Katram darbiniekam iespējams konfigurēt savu balss paskastītiti.</li>
						<li>Neierobežots skaits iekšējo tālruņa numuru.</li>
						<li>Iespēja ērti administrēt iekšējos numurus, izmantojot administrēšanas vidi</li>
						<li>Zvanu ieraksta iespēja un droša ierakstu uzglabāšana (visi dati tiek glabāti 3 kopijās uz fizisiki neatkarīgām iekārtām)</li>
						<li>Datu centra un telefonijas infrastruktūras atbilstība GDPR datu aizsardzības regulai</li>
					</ul>
				</article>
				<div class="widget plan">
					<h3><span class="from"><Text id="cart.from"/></span><span class="value">€39</span><span class="term"> <Text id="cart.month.full"/></span></h3>
				     <ul class="bullet">
				     	<li>Bezmaksas ierīkošana</li>
				     	<li>Slēdzot līgumu uz 12 mēnešiem dāvanā 16 līniju telefona aparāts ar krāsainu displeju.</li>
				     </ul>
				     <div><Link href={store.prefix+'/contact?service=pbx&form=true'} class="button"><Text id="email.widget.list.btn"/></Link></div>
				</div>
				<div class="clearfix"/>
				<article>
					<h2>Sarunu tarifi</h2>
					<LazyComponent getComponent={()=>import('./tariffs')}/>
				</article>
				</ServiceWrapper>);
	}
}



// WEBPACK FOOTER //
// ./routes/services/pbx.js